// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scrollbar-gutter: stable;
}
body {
  margin: 0;
}
body * {
  outline: none;
}
.highlighted-row > td {
  background-color: #c7ecfd !important;
  transition: background-color 0.5s ease-in-out;
}
.highlighted-row-fadeout > td {
  background-color: transparent !important;
  transition: background-color 1s ease-out;
}
.temp-highlight td {
  background-color: #fffbe6 !important;
  transition: background-color 0.3s ease-out;
}
.selected-for-mapping-row td {
  background-color: #e6f7ff !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/global-styles.less"],"names":[],"mappings":"AAGA;EACE,wBAAA;AAFF;AAKA;EAKE,SAAA;AAPF;AAEA;EAEI,aAAA;AADJ;AAOA;EACE,oCAAA;EACA,6CAAA;AALF;AAQA;EACE,wCAAA;EACA,wCAAA;AANF;AASA;EACE,oCAAA;EACA,0CAAA;AAPF;AAUA;EACE,oCAAA;AARF","sourcesContent":["// @import '~antd/es/style/themes/default.less';\n// @import 'defaultTheme.json';\n\nhtml {\n  scrollbar-gutter: stable;\n}\n\nbody {\n  * {\n    outline: none;\n  }\n\n  margin: 0;\n}\n\n.highlighted-row > td {\n  background-color: #c7ecfd !important;\n  transition: background-color 0.5s ease-in-out;\n}\n\n.highlighted-row-fadeout > td {\n  background-color: transparent !important;\n  transition: background-color 1s ease-out;\n}\n\n.temp-highlight td {\n  background-color: #fffbe6 !important;\n  transition: background-color 0.3s ease-out;\n}\n\n.selected-for-mapping-row td {\n  background-color: #e6f7ff !important;\n}\n\n@primary-color: #00677F;@primary-color-hover: #00677F;@primary-color-active: #fafdfd;@primary-color-outline: #00677F;@font-size-base: 12px;@border-color-base: #bfbfbf;@border-color-inverse: #000000;@progress-default-color: #F1B44C;@processing-color: #00677F;@text-color: #495057;@heading-color: #495057;@table-selected-row-bg: #fafdfd;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
